import { render, staticRenderFns } from "./SlideLimit.vue?vue&type=template&id=2d5d51a7&"
import script from "./SlideLimit.vue?vue&type=script&lang=js&"
export * from "./SlideLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports